import * as React from 'react'
import styled from 'styled-components'
import { inject, observer } from 'mobx-react'
import * as Autocomplete from 'react-autocomplete'
import backend from 'src/api'
import { ConfiguratorText } from 'src/components/atoms/configurator'
import { ConfiguratorBox } from 'src/components/containers/configurator/ConfiguratorBox'
import { StoreProps } from 'src/stores'
import { media } from 'src/utils.js'

interface Props extends StoreProps {
  index?: number
}

@inject('confStore')
@observer
export default class MusicSelection extends React.Component<Props, any> {
  constructor(props) {
    super(props)
    const { confStore } = props
    this.state = {
      isDropdownOpen: false,
      searchTerm: '',
      searchResults: [],
      musicList: confStore.getDocumentsEntriesByType('music')
    }
  }

  handleOnChange = (e) => {
    this.setState({
      searchTerm: e.target.value
    })
    if (e.target.value) {
      backend.searchTrack(e.target.value, (result) => {
        this.setState({
          searchResults: result.trackSearch || [],
          isDropdownOpen: true
        })
      })
    } else {
      this.setState({ searchResults: [], isDropdownOpen: false })
    }
  }

  handleBlur = (_e) => {
    this.setState({ isDropdownOpen: false })
  }

  handleSelect = (e) => {
    const { confStore } = this.props
    const { musicList } = this.state
    const newEntry = new Map<string, any>()
    newEntry.set('name', e.name)
    newEntry.set('artist', e.artist)
    musicList.push(newEntry)
    this.setState({
      musicList,
      searchTerm: '',
      searchResults: [],
      isDropdownOpen: false
    })
    confStore.setDocumentsEntry('music', musicList)
  }

  handleKeyPress = (e) => {
    const { searchResults, searchTerm } = this.state
    if (e.keyCode === 13 && !searchResults.length && searchTerm.length) {
      this.handleSelect({ name: searchTerm, artist: '' })
    }
  }

  renderTextInput = (props) => {
    const { ref, ...rest } = props
    const { searchTerm } = this.state
    return (
      <MusicInput
        type='text'
        placeholder='Musiktitel suchen'
        value={searchTerm}
        {...rest}
        ref={ref}
      />
    )
  }

  renderMenu = (items) => {
    if (items.length) {
      return <MenuItem>{items}</MenuItem>
    }
    const { searchTerm } = this.state
    return (
      <MenuItem
        onClick={() => this.handleSelect({ name: searchTerm, artist: '' })}>
        {searchTerm}
      </MenuItem>
    )
  }

  handleDelete = (index) => {
    const { confStore } = this.props
    const { musicList } = this.state
    musicList.splice(index, 1)
    this.setState({ musicList })
    confStore.setDocumentsEntry('music', musicList)
  }

  render() {
    const { index } = this.props
    const { isDropdownOpen, searchResults, searchTerm, musicList } = this.state
    return (
      <ConfiguratorBox
        title={`${index}. Musikauswahl`}
        collapsable
        idLabel={`expand-arrow-music-selection`}        
        showOverflow
        defaultCollapsed>
        <ConfiguratorText>
          Welche Musik soll auf Ihrer Trauerfeier gespielt werden?
        </ConfiguratorText>
        <Autocomplete
          wrapperStyle={{
            width: '100%',
            marginBottom: '15px',
            position: 'relative',
            borderBottom: '2px solid #a7c9cd',
            fontSize: 15
          }}
          renderInput={(props) => this.renderTextInput(props)}
          menuStyle={{
            position: 'absolute',
            zIndex: '9999',
            fontSize: 15,
            top: '',
            left: '',
            boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
            background: 'rgba(255, 255, 255, 0.9)',
            padding: 10,
            maxHeight: 210,
            overflow: 'hidden'
          }}
          renderMenu={(items, _value, _style) => this.renderMenu(items)}
          items={searchResults}
          getItemValue={(item) => `${item.name} - ${item.artist}`}
          renderItem={(item, highlighted, index) => {
            const name =
              item.name.length > 40
                ? `${item.name.substring(0, 40)}...`
                : item.name
            const artist =
              item.artist.length > 30
                ? `${item.artist.substring(0, 30)}...`
                : item.artist
            return (
              <div
                key={`${item.name} - ${item.artist} - ${index}`}
                className={'music-item'}
                style={{
                  backgroundColor: highlighted ? '#d5e4e6' : 'transparent',
                  padding: 5,
                  cursor: 'pointer'
                }}>
                {name} - {artist}
              </div>
            )
          }}
          open={isDropdownOpen}
          value={searchTerm}
          onChange={(e) => this.handleOnChange(e)}
          onSelect={(_value, item) => this.handleSelect(item)}
          inputProps={{
            onBlur: this.handleBlur,
            onKeyDown: this.handleKeyPress
          }}
        />
        {musicList.map((m, i) => {
          return (
            <MusicEntry>
              <p>{m.get('name')}</p>
              <p>{m.get('artist')}</p>
              <Delete onClick={() => this.handleDelete(i)}>
                <i className='far fa-trash-alt' />
              </Delete>
            </MusicEntry>
          )
        })}
      </ConfiguratorBox>
    )
  }
}

export const MusicInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  width: 100%
  height: 45px;
  padding: 0 7.5px;
  z-index: 12;
  line-height: 45px;

  &::placeholder {
      color: #9a9a9a;
  }
`
 
const MenuItem = styled.div`
  position: absolute;
  font-size: 18px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 12px;
  background: rgba(255, 255, 255, 0.9);
  padding: 10px;
  max-height: 210px;
  overflow: hidden;
  width:100%;
  z-index: 50;

  ${media.giant`font-size: 18px;`}
  ${media.desktop`font-size: 16px;`}
  ${media.tablet`font-size: 14px;`}
  ${media.phone`font-size: 14px;`}
`

const MusicEntry = styled.div`
  position: relative;
  padding: 7.5px;
  &:nth-child(odd) {
    background: #d5e4e6;
  }

  p {
    display: inline-block;
    width: 60%;
    margin: 0;
    padding-right: 30px;
    line-height: 1.6;
    vertical-align: middle;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    &:nth-child(2) {
      width: auto;
    }
  }
  ${media.largePhone`
    p {
      width: 100%;
      &:nth-child(2) {
        display: none;
      }
    }
  `}
`
const Delete = styled.div`
  position: absolute;
  width: 25px;
  height: 15px;
  right: 7.5px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  text-align: center;
  line-height: 15px;
  & > i {
    color: #677d7f;
  }
`



// WEBPACK FOOTER //
// ./src/components/organisms/configurator/MusicSelection.tsx